import { memo } from 'react';

function ContactDetailsIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#919EAB" fillOpacity="0.24" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 13V27C11 28.1 11.89 29 13 29H27C28.1 29 29 28.1 29 27V13C29 11.9 28.1 11 27 11H13C11.89 11 11 11.9 11 13ZM23 17C23 18.66 21.66 20 20 20C18.34 20 17 18.66 17 17C17 15.34 18.34 14 20 14C21.66 14 23 15.34 23 17ZM20 21.9C18 21.9 14 23 14 25V26H26V25C26 23 22 21.9 20 21.9Z"
        fill="#637381"
      />
    </svg>
  );
}

export default memo(ContactDetailsIcon);
